import { UPLOAD_FOB_FOTO_API_URL, GET_FOB_FOTO_API_URL, DELETE_FOB_FOTO_API_URL } from "../../OpticApiConfig";

// Функция загрузки фото с сервера Coupling
export const loadFobImagesFromServer = async (fobLocationId, setServerImageUrls, setUploadMessage) => {
  const token = localStorage.getItem('token');
  if (!token) {
      console.log('Ошибка! Токен не найден');
      return;
  }
    try {
      const response = await fetch(`${GET_FOB_FOTO_API_URL}?fobLocationId=${fobLocationId}`, { 
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}` 
        }
      });
  
      if (!response.ok) {
        throw new Error('Ошибка при загрузке файлов с сервера.');
      }
  
      const imageList = await response.json();
  
      if (imageList.length === 0) {
        setUploadMessage('Файлов не найдены.');
        setServerImageUrls([]);
        return;
      }
  
      const imageUrls = imageList.map(image => {
        const url = `data:${image.contentType};base64,${image.fileContent}`;
        return { url, fileName: image.fileName };
      });
  
      setServerImageUrls(imageUrls);
      setUploadMessage('');
    } catch (error) {
      setUploadMessage('Ошибка загрузки файлов с сервера: ' + error.message);
    }
  };


  // Функция для загрузки фото Fob на сервер
export const uploadFobImage = async (file, fobLocationId, setFileName, setIsFileUploaded, setServerImageUrls, setUploadMessage, user) => {
   
    const token = localStorage.getItem('token');
      if (!token) {
          console.log('Ошибка! Токен не найден');
          return;
      }

    setFileName(file.name);
    setIsFileUploaded(true);
  
    const formData = new FormData();
    formData.append('file', file);
    formData.append('fobLocationId', fobLocationId);
    formData.append('user', user);
  
    try {
      const response = await fetch(UPLOAD_FOB_FOTO_API_URL, {
        method: 'POST',
        body: formData,
        headers: {
          'Authorization': `Bearer ${token}` 
        }
      });
  
      const textResult = await response.text();
      try {
        const result = JSON.parse(textResult);
        if (response.ok) {
          setUploadMessage(result.message);
  
          // После успешной загрузки фото загружаем обновленный список изображений
          await loadFobImagesFromServer(fobLocationId, setServerImageUrls, setUploadMessage);
        } else {
          setUploadMessage('Ошибка загрузки файла: ' + result.message);
        }
      } catch (parseError) {
        setUploadMessage('Ошибка загрузки файла: ' + textResult);
      }
    } catch (error) {
      setUploadMessage('Ошибка загрузки файла: ' + error.message);
    }
  };


  // Функция для удаления фото Fob на сервере
export const deleteFobImage = async (fileName, fobLocationId, setServerImageUrls, setUploadMessage) => {
  
  const token = localStorage.getItem('token');
      if (!token) {
          console.log('Ошибка! Токен не найден');
          return;
      }

    try {
      const response = await fetch(`${DELETE_FOB_FOTO_API_URL}?fobLocationId=${fobLocationId}&fileName=${fileName}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}` 
        }
      });
  
      const result = await response.json();
      if (response.ok) {
        setUploadMessage(result.message);
        // Обновляем список изображений
        await loadFobImagesFromServer(fobLocationId, setServerImageUrls, setUploadMessage);
      } else {
        setUploadMessage('Ошибка удаления файла: ' + result.message);
      }
    } catch (error) {
      setUploadMessage('Ошибка удаления файла: ' + error.message);
    }
  };